import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, finalize, map, startWith } from 'rxjs/operators';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Company } from 'src/app/core/interfaces/company';
import { CostCenter } from 'src/app/core/interfaces/costCenter';
import { DataDialogCargoBilling } from 'src/app/core/interfaces/dataDialogCargoBilling';
import { Utils } from 'src/app/core/resources/utils';
import { AuthService } from 'src/app/core/services/authentication.service';
import { CompaniesService } from '../../administration/companies/list-companies.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { FreightListService } from '../cargo-list/cargo-list.service';
import { CargoBilling } from 'src/app/core/interfaces/cargoBilling';
import { BasicResponse } from 'src/app/core/interfaces/basicResponse';
import { CargoItemService } from '../cargo-item/cargo-item.service';
import ContentTypes from 'src/app/core/resources/content-type-ext.json';
import { OpenImgComponent } from 'src/app/shared/open-img/open-img.component';
import { Fmt } from 'src/app/core/messages/fmt';
import { ResourceMessages } from 'src/app/core/messages/resource-messages.enum';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DateManager } from 'src/app/core/managers/date.manager';
import { PaymentType } from 'src/app/core/interfaces/paymentType';
import { Router } from '@angular/router';
import { BillingUser } from 'src/app/core/interfaces/billingUser';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { AdminUsersService } from '../../administration/admin-users/admin-users.service';
import { UserClient } from 'src/app/core/interfaces/userClient';
import { CompanyBillingIntegrationService } from 'src/app/core/services/company-billing-integration.service';
import { CatalogService } from 'src/app/core/services/catalog.service';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';
import { Dialog } from 'src/app/core/resources/dialog';
import { AccountService } from '../../account/account.service';
import { environment } from 'src/environments/environment';
import { resolveCargosTransportNit } from 'src/app/core/resources/transport-company-context.utils';
import { TransportCompanyGuardService } from 'src/app/core/services/transport-company-guard.service';

@Component({
  selector: 'app-cargo-billing',
  templateUrl: './cargo-billing.component.html',
  styleUrls: ['./cargo-billing.component.scss']
})
export class CargoBillingComponent implements OnInit {

  listCostCenter: Observable<CostCenter[]>;
  listBillingProducts: Observable<CatalogItem[]>;
  companyCostCenters: CostCenter[] = [];
  companyCostCentersLoaded = false;
  costCenters: CostCenter[] = [];
  paymentTypes: PaymentType[] = [];
  billingProducts: CatalogItem[] = [];
  form: FormGroup;
  cargos: Cargo[] = [];
  nitCompany: string;
  company: Company;
  typeBilling: string;
  // Empresa de transporte común a los servicios; null si no la tienen (servicios previos a la división).
  transportNit: string = null;
  showAllCostCenters = new FormControl(false);
  billType: string = 'integration';
  costCenterControl: FormControl = new FormControl('');
  productControl: FormControl = new FormControl(null, [Validators.required]);
  subscriptions: Subscription = new Subscription();
  pageKey: number = 1;
  canLoadMoreBillingUsers: boolean = false;
  listBillingUsers: BillingUser[] = [];
  messageListBillingUsers: string = '';
  sellerControl: FormControl = new FormControl(null);
  defaultSeller: BillingUser;
  minDueDate: Date = new Date();
  readonly DUE_DATE_MIN_MESSAGE: string = Fmt.string(FormMessages.DATE_NOT_REACHED, 'vencimiento', 'hoy');
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) inputAutoComplete: MatAutocompleteTrigger;


  constructor(
    private transportCompanyGuard: TransportCompanyGuardService,
    @Inject(MAT_DIALOG_DATA) public dialogParams: DataDialogCargoBilling,
    public dialogRef: MatDialogRef<CargoBillingComponent>,
    public utils: Utils,
    public authService: AuthService,
    private companiesService: CompaniesService,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    public cargoListService: FreightListService,
    private cargoItemService: CargoItemService,
    public dialog: MatDialog,
    private router: Router,
    private adminUsersService: AdminUsersService,
    private readonly companyBillingIntegration: CompanyBillingIntegrationService,
    private readonly catalogService: CatalogService,
    private dialogPrompt: Dialog,
    public accountService: AccountService
  ) {
    this.validateDataDialog();
    this.createForm();
  }

  ngOnInit() {
    // Segunda barrera: list-operations ya lo valida antes de abrir el diálogo.
    if (!this.transportCompanyGuard.ensureSameTransportCompany(this.cargos, this.dialogParams && this.dialogParams.transportCompanyId)) {
      this.dialogRef.close();
      return;
    }
    if (this.hasSiigoIntegration || this.isBusinessCentralBilling) {
      this.billType = 'integration';
      this.getCompanyCostCenters();
      if (this.hasSiigoIntegration)
        this.getPaymentMethods();
      if (this.isBusinessCentralBilling)
        this.loadBillingProducts();
      else if (this.isBillIntegration)
        this.getBillingUsers();
    } else {
      this.billType = 'exported';
      this.form.get('billingId').setValue('Exportado');
    }
    this.setValidators();
    this.subscriptions.add(this.costCenterControl.valueChanges
      .subscribe(value => this.form.get('costCenter').setValue(value && value.name && this.utils.isDefined(value.id) ? value : '')));
    this.subscriptions.add(this.productControl.valueChanges
      .subscribe(value => this.form.get('product').setValue(value && value.name ? value : null)));
    this.subscriptions.add(this.sellerControl.valueChanges
      .subscribe(value => this.form.get('seller').setValue(value && value.id ? value.id : null)));
  }

  /**
   * Catálogo BC; headers estándar los aplica el interceptor HTTP.
   */
  private loadBillingProducts(): void {
    this.spinner.show();
    this.catalogService.getBillingProducts().pipe(finalize(() => this.spinner.hide())).subscribe(
      (items) => {
        this.billingProducts = items && items.catalog && items.catalog.length ? items.catalog : [];
        this.createProductsAutocomplete();
      },
      () => this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error')
    );
  }

  async getLoggedUser() {
    try {
      const userLoggedDocument = this.authService && this.authService.getUserSession() && this.authService.getUserSession().information && this.authService.getUserSession().information.document;
      const users: UserClient[] = await this.adminUsersService.getUserClientByDocument(userLoggedDocument).toPromise();
      if (users && users.length) {
        const user = users[0];
        const billingUser = this.listBillingUsers.find((billingUserItem: BillingUser) => (billingUserItem.id).toString() === user.siigoId);
        if (billingUser) {
          this.defaultSeller = billingUser;
          this.sellerControl.setValue(billingUser);
        }
      }
    } catch (error) {
      console.error('error:', error);
    }
  }

  createInstanceAutocomplete() {
    this.listCostCenter = this.costCenterControl.valueChanges.pipe(
      startWith(''),
      distinctUntilChanged(),
      map(value => {
        const list = this.showAllCostCenters.value ? this.costCenters : this.companyCostCenters;
        const valueName = value && value.name ? value.name : typeof value === 'string' ? value : '';
        return list.filter(option => option.name.toLowerCase().includes(valueName.toLowerCase()));
      })
    );
  }

  createProductsAutocomplete(): void {
    this.listBillingProducts = this.productControl.valueChanges.pipe(
      startWith(''),
      distinctUntilChanged(),
      map(value => {
        const valueName = this.utils.getNestedValue(value, 'name') ? this.utils.getNestedValue(value, 'name') : value || '';
        return this.billingProducts.filter(option => option.name.toLowerCase().includes(valueName.toLowerCase()));
      })
    );
  }

  validateDataDialog() {
    if (!this.utils.isEmpty(this.dialogParams) && !this.utils.isEmpty(this.dialogParams.cargos)) {
      this.cargos = this.dialogParams.cargos;
    }
    // Manda la empresa elegida en la pastilla del listado; si no viene (SaaS sin transporte o
    // apertura sin listado) se toma la de los servicios. ngOnInit bloquea mezclas o diferencias.
    this.transportNit = (this.dialogParams && this.dialogParams.transportCompanyId)
      || resolveCargosTransportNit(this.cargos).transportNit;
    if (!this.utils.isEmpty(this.dialogParams) && !this.utils.isEmpty(this.dialogParams.nitCompany)) {
      this.nitCompany = this.dialogParams.nitCompany;
    }
    if (!this.utils.isEmpty(this.dialogParams) && !this.utils.isEmpty(this.dialogParams.company)) {
      this.company = this.dialogParams.company;
    }
    if (!this.utils.isEmpty(this.dialogParams) && !this.utils.isEmpty(this.dialogParams.typeBilling)) {
      this.typeBilling = this.dialogParams.typeBilling;
    }
  }

  createForm() {
    this.form = new FormGroup({
      costCenter: new FormControl(''),
      cargos: new FormControl(
        this.cargos.map(cargo => cargo.id),
        [Validators.required]
      ),
      company: new FormControl(
        this.nitCompany,
        [Validators.required]
      ),
      billingId: new FormControl(
        ''
      ),
      observations: new FormControl(
        ''
      ),
      dueDate: new FormControl(
        null
      ),
      paymentType: new FormControl(
        ''
      ),
      sendDIAN: new FormControl(
        false,
      ),
      sendEmail: new FormControl(
        false
      ),
      seller: new FormControl(
        null
      ),
      product: new FormControl(null),
    });
  }

  setValidators() {
    if (!this.isBill || (this.isBill && !this.isBillIntegration)) {
      this.form.get('billingId').setValidators([Validators.required]);
      this.form.get('billingId').updateValueAndValidity();
    }
    if (this.isBillIntegration) {
      this.form.get('costCenter').setValidators([Validators.required]);
      this.form.get('costCenter').updateValueAndValidity();
      this.costCenterControl.setValidators(Validators.required);
      this.costCenterControl.updateValueAndValidity();

      if (this.isBusinessCentralBilling) {
        this.form.get('product').setValidators([Validators.required]);
        this.form.get('product').updateValueAndValidity();
        return;
      }
      this.form.get('dueDate').setValidators([Validators.required]);
      this.form.get('dueDate').updateValueAndValidity();
      const expirationDays: number = this.utils.getNestedValue(this.company, 'billingConfiguration.expirationDays');
      if (expirationDays && this.hasSiigoIntegration)
        this.form.get('dueDate').setValue(DateManager.add(new Date(), expirationDays, 'days'));
      this.form.get('dueDate').updateValueAndValidity();

      if (this.isTeclogiUser) {
        this.form.get('costCenter').setValidators([Validators.required]);
        this.form.get('costCenter').updateValueAndValidity();
      }

      this.form.get('billingId').setValidators([]);
      this.form.get('billingId').updateValueAndValidity();

      if (this.hasSiigoIntegration) {
        this.form.get('paymentType').setValidators(Validators.required);
        this.form.get('paymentType').updateValueAndValidity();
      }
    }
    if (this.isBill && !this.isBillIntegration) {
      this.form.get('dueDate').clearValidators();
      this.form.get('dueDate').updateValueAndValidity();

      this.form.get('costCenter').clearValidators();
      this.form.get('costCenter').updateValueAndValidity();

      this.costCenterControl.clearValidators();
      this.costCenterControl.updateValueAndValidity();
    }
  }

  /** Centros de costo de la empresa cliente para la empresa de transporte; sin ellos, el catálogo general. */
  async getCompanyCostCenters(): Promise<void> {
    this.companyCostCenters = [];
    if (this.nitCompany) {
      this.spinner.show();
      try {
        this.companyCostCenters = await this.companiesService.getCompanyCostCenters(this.nitCompany, this.transportNit).toPromise() || [];
      } catch (error) {
        this.companyCostCenters = [];
      } finally {
        this.spinner.hide();
      }
    }
    this.companyCostCentersLoaded = true;
    if (this.companyCostCenters.length) this.showAllCostCenters.setValue(false);
    // Sin Siigo solo se usan los asociados: no hay catálogo general ni "Mostrar todos".
    if (!this.companyCostCenters.length && this.hasSiigoIntegration) {
      this.showAllCostCenters.setValue(true);
      this.getCostCenters();
    } else {
      this.createInstanceAutocomplete();
    }
  }

  getCostCenters() {
    if (!this.costCenters.length) {
      this.spinner.show();
      this.companiesService.getCostCenters(this.transportNit).toPromise()
        .then((success) => {
          this.costCenters = success;
          this.createInstanceAutocomplete();
        })
        .catch(() => {
          this.costCenters = [];
        })
        .finally(() => this.spinner.hide());
    }
  }

  getPaymentMethods() {
    this.spinner.show();
    this.companiesService.getPaymentTypes(this.transportNit).subscribe(
      (success) => {
        this.spinner.hide();
        if (success && success.length) { this.paymentTypes = success; }
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  displayCostCenterSelected(costCenter: CostCenter) {
    return costCenter ? costCenter.name || '' : '';
  }

  toggleListCostCenter(): void {
    if (this.showAllCostCenters.value) {
      this.getCostCenters();
    }
    this.createInstanceAutocomplete();
  }

  displayProductSelected(product: CatalogItem): string {
    return product ? product.name || '' : '';
  }

  onChangeSeller() {
    const userLoggedDocument = this.authService && this.authService.getUserSession() && this.authService.getUserSession().information && this.authService.getUserSession().information.document;
    const sellerId = this.sellerControl && this.sellerControl.value && this.sellerControl.value.id;
    if (userLoggedDocument && sellerId) {
      const setInfoUserClientObserver = {
        next: (success: { message: string }) => {
          if (success && success.message === 'Actualizado') {
            this.defaultSeller = this.sellerControl.value;
            this.snackBarService.openSnackBar(`Se ha establecido a ${this.sellerControl.value.firstName} ${this.sellerControl.value.lastName} como vendedor predeterminado correctamente`);
          }
        },
        error: () => {
          this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        }
      };
      this.spinner.show();
      this.companiesService.setInfoUserClient(userLoggedDocument, sellerId.toString()).pipe(finalize(() => this.spinner.hide())).subscribe(setInfoUserClientObserver);
    } else { this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error'); }
  }

  onSubmit() {
    this.form.markAllAsTouched();
    this.costCenterControl.markAsTouched();
    this.productControl.markAsTouched();
    if (this.form.valid && this.hasCostCenterValid())
      return this.cashedCargo();
    this.form.updateValueAndValidity();
    if (this.utils.errorMessagesCustomized(this.form.get('cargos'), 'servicios')) return;
    else if (this.utils.errorMessagesCustomized(this.form.get('company'), 'compañía')) return;
    else if (this.isBusinessCentralBilling) {
      if (this.utils.errorMessagesCustomized(this.form.get('product'), 'producto')) return;
      return this.snackBarService.openSnackBar(FormMessages.MISSING_FIELDS, undefined, 'alert');
    }
    else if (this.utils.errorMessagesCustomized(this.form.get('dueDate'), 'fecha de vencimiento', null, null, null, null, {
      matDatepickerMin: this.DUE_DATE_MIN_MESSAGE
    })) return;
    else if (this.utils.errorMessagesCustomized(this.form.get('costCenter'), 'centro de costo')) return;
    else if (!this.utils.isDefined((this.form.get('costCenter').value as CostCenter).id))
      return this.snackBarService.openSnackBar(Fmt.string(FormMessages.MISSING_FIELD, 'centro de costo'), undefined, 'alert');
    else if (this.utils.errorMessagesCustomized(this.form.get('billingId'), this.isBill && !this.isBillIntegration ? 'nº de Factura' : 'nº de Comprobante'))
      return;
    else if (this.utils.errorMessagesCustomized(this.form.get('paymentType'), 'método de pago')) return;
    else if (this.utils.errorMessagesCustomized(this.form.get('observations'), 'observaciones')) return;
    else return this.snackBarService.openSnackBar(FormMessages.MISSING_FIELDS, undefined, 'alert');
  }

  hasCostCenterValid(): boolean {
    if (!this.isTeclogiUser) return true;
    if (!this.isBill) return true;
    if (this.billType === 'exported') return true;
    if (this.isBusinessCentralBilling) return true;
    const center = this.form.get('costCenter').value as CostCenter;
    return this.utils.isDefined(center && center.id);
  }

  cashedCargo() {
    let body: CargoBilling = this.utils.clone(this.form.value);
    if (body.costCenter && body.costCenter.name)
      body.costCenter = { id: body.costCenter['id'], code: body.costCenter['code'], name: body.costCenter.name };
    if (body.dueDate)
      body.dueDate = DateManager.dateToString(this.form.get('dueDate').value, 'YYYY-MM-DD');
    if (!this.isBillIntegration) {
      delete body.costCenter;
      delete body.observations;
      delete body.dueDate;
      delete body.sendDIAN;
      delete body.sendEmail;
      delete body.product;
    } else {
      delete body.billingId;
      if (!this.hasSiigoIntegration) delete body.paymentType;
      if (this.isBusinessCentralBilling) {
        delete body.dueDate;
        delete body.sendDIAN;
        delete body.sendEmail;
      }
    }
    body.cargos = this.cargos.map(cargo => cargo.id);
    this.spinner.show();
    this.cargoListService.cashedCargo(body, this.typeBilling, this.transportNit).toPromise()
      .then((success: BasicResponse) => {
        if (success.message === 'Update') {
          this.snackBarService.openSnackBar('Se ha enviado la información correctamente');
          if (this.isBillIntegration) {
            if (this.isBusinessCentralBilling) {
              this.spinner.hide();
              this.dialogRef.close({ state: true });
              return;
            }
            if (this.showAllCostCenters.value) {
              this.associateCostCenter(this.form.value.costCenter);
            }
            this.getCargoInvoicePDF(this.form.value.cargos[0]);
          } else {
            this.spinner.hide();
            this.dialogRef.close({ state: true });
          }
        } else if (success.message) {
          this.spinner.hide();
          this.snackBarService.openSnackBar(success.message, undefined, 'error');
        } else {
          this.spinner.hide();
          this.snackBarService.openSnackBar('Ocurrió un error al realizar la facturación, contacte al Administrador', undefined, 'error');
        }
      })
      .catch((error) => {
        this.spinner.hide();
        const backendMessage = error && error.error && error.error.message;
        if (error && error.status === 400 && backendMessage) {
          this.dialogPrompt.openDialog({
            title: 'No se puede facturar',
            description: backendMessage,
            iconError: true,
            hideBtnCancel: true
          }).then().catch(err => err);
          return;
        }
        this.snackBarService.openSnackBar('Ocurrió un error al enviar la información', undefined, 'error');
      });
  }

  associateCostCenter(costCenter: CostCenter) {
    this.spinner.show();
    this.companiesService.associateCostCenter(costCenter, this.nitCompany, this.transportNit).toPromise()
      .then((response) => {
        this.spinner.hide();
        if (this.companiesService.isAssociateCostCenterSuccess(response))
          this.snackBarService.openSnackBar('Centro de costo asociado correctamente');
        else
          this.snackBarService.openSnackBar(this.companiesService.costCenterResponseMessage(response), undefined, 'error');
      })
      .catch(() => {
        this.spinner.hide();
        this.snackBarService.openSnackBar('Ocurrió un error al enviar la información', undefined, 'error');
      });
  }

  getCargoInvoicePDF(cargoId: string) {
    this.cargoItemService.getCargoInvoicePDF(cargoId).toPromise()
      .then((response) => {
        const file = new Blob([response], { type: ContentTypes.pdf });
        const fileURL = URL.createObjectURL(file);
        this.openDocumentExtra(response, fileURL);
        this.dialogRef.close({ state: true });
      })
      .catch(() => this.snackBarService.openSnackBar(Fmt.string(ResourceMessages.ERROR_LOAD, 'la factura'), undefined, 'error'))
      .finally(() => this.spinner.hide());
  }

  openDocumentExtra(blob: Blob, url: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Factura`,
      src: url,
      confirmBtn: 'Descargar'
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(OpenImgComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.state) {
        this.utils.downloadFile(blob, 'Factura', ContentTypes.pdf);
      }
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  goToAdministrativeConfiguration(tab: string) {
    this.router.navigate(['/administration/companies/detail', this.nitCompany], {
      state: { tab: tab }
    });
    this.dialogRef.close();
  }

  getBillingUsers() {
    const listBillingUsers = {
      next: async (billingUsers: BillingUser[]) => {
        if (billingUsers && billingUsers.length) {
          this.listBillingUsers = [...this.listBillingUsers, ...billingUsers];
          if (this.pageKey === 1) await this.getLoggedUser();
        }
        else if (this.pageKey === 1) this.messageListBillingUsers = Fmt.string(ServiceMessages.NO_DATA_FOUND, 'vendedores');
        this.canLoadMoreBillingUsers = !!(billingUsers && billingUsers.length && billingUsers.length === 25);
        this.spinner.hide();
      },
      error: () => {
        this.messageListBillingUsers = Fmt.string(ServiceMessages.ERROR_GETTING_DATA, 'vendedores');
        this.spinner.hide();
      }
    };
    this.spinner.show();
    this.companiesService.listBillingUsers(this.pageKey, 25, this.transportNit).subscribe(listBillingUsers);
  }

  getMoreBillingUsers() {
    this.pageKey++;
    this.getBillingUsers();
  }

  ngOnDestroy() {
    if (this.subscriptions) this.subscriptions.unsubscribe();
  }

  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }

  get isBill() {
    return this.typeBilling === 'bill';
  }

  get isBillIntegration() {
    return this.isBill && this.billType === 'integration';
  }

  get hasSiigoIntegration(): boolean {
    return this.companyBillingIntegration.isSiigoBilling();
  }

  get isBusinessCentralBilling(): boolean {
    return this.companyBillingIntegration.isBusinessCentralBilling();
  }

}
